import React from 'react';

export default class Video extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="video-component py-5">
        <div className="container">
          <div className="d-flex flex-column align-items-center text-center">
            <h1 className="text-primary">ROI Calculator Demo Video</h1>
            <p className="text-secondary" style={{ maxWidth: '600px' }}>Watch to learn how to use the Qlik Sene ROI Calculator.</p>
          </div>
          <div className="row">
            <div className="col">
              <div className="embed-responsive embed-responsive-16by9 border border-gray300">
                <video src="assets/ROI Calculator v1.mp4" controls />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/Video/index.js